import { useEffect, useState } from 'react';

/** Se suscribe a una media query y sigue los cambios (rotar el celular incluido). */
export function useMedia(consulta: string): boolean {
  const [coincide, setCoincide] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(consulta).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(consulta);
    const alCambiar = (e: MediaQueryListEvent) => setCoincide(e.matches);
    setCoincide(mq.matches);
    mq.addEventListener('change', alCambiar);
    return () => mq.removeEventListener('change', alCambiar);
  }, [consulta]);

  return coincide;
}

/**
 * Celular o tablet del depósito. Es el mismo corte que usa el CSS para
 * reemplazar la barra lateral por chips, así layout y markup no se separan.
 */
export const useEsTactil = () => useMedia('(max-width: 1080px)');

/**
 * Celular de mano, no tablet. Es el corte donde los paneles flotantes dejan de
 * entrar al costado del dibujo y tienen que pasar a ocupar el ancho completo.
 */
export const useEsCelular = () => useMedia('(max-width: 720px)');
